const MarqueeRow = ({ items, ariaHidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-lg font-medium tracking-wide text-white/85 md:text-xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-[#E8912D]" />
      </span>
    ))}
  </div>
);

const Marquee = ({ items }) => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-white/10 bg-navy py-5"
  >
    <div className="animate-marquee flex w-max">
      <MarqueeRow items={items} />
      <MarqueeRow items={items} ariaHidden />
    </div>
  </div>
);

export default Marquee;
